import { Table } from '@tiptap/extension-table';

// 生成唯一ID的函数
const generateUniqueId = () => {
    return `table-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

export const CustomTable = Table.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            aimlTableId: {
                default: () => generateUniqueId(), // 使用函数生成默认值
                parseHTML: (element) => {
                    // 从包裹的 div 获取 ID，如果没有则生成新ID
                    const wrapper = element.closest('div[data-table-id]');
                    return wrapper?.getAttribute('data-table-id') || generateUniqueId();
                },
                renderHTML: (attributes) => ({
                    'data-table-id': attributes.aimlTableId || generateUniqueId(),
                }),
            },
        };
    },

    parseHTML() {
        return [
            ...(this.parent?.() || []),
            {
                tag: 'div[data-table-id] table', // 定位被包裹的表格
                priority: 100, // 提高解析优先级
            },
        ];
    },
});
